import type { Action } from '@ngrx/store';
import { createAction, props } from '@ngrx/store';

const prefillSingleFieldFormActionType =
  '[single field form] prefillSingleFieldFormAction';
export interface PrefillSingleFieldFormProps {
  controlId: string;
  value: any;
}

export type PrefillSingleFieldFormActionType = PrefillSingleFieldFormProps &
  Action<typeof prefillSingleFieldFormActionType>;

export const prefillSingleFieldFormAction = createAction(
  prefillSingleFieldFormActionType,
  props<PrefillSingleFieldFormProps>()
);
